"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import PlayButton from "../ui/playbutton";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getSectionUrl, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  sectionUrl?: string;
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  className?: string;
  slug?: string;
  imageMetadata?: ImageMetadata;
};
export const VerticalBigVideoNewsBlack = t0 => {
  const $ = _c(60);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    timeAgo: t4,
    imageSrc: t5,
    slug,
    imageMetadata
  } = t0;
  let t6;
  if ($[0] !== t1) {
    t6 = t1 === undefined ? {
      hidden: false,
      value: "LIFESTYLE",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const category = t6;
  let t7;
  if ($[2] !== t2) {
    t7 = t2 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const title = t7;
  let t8;
  if ($[4] !== t3) {
    t8 = t3 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  const excerpt = t8;
  let t9;
  if ($[6] !== t4) {
    t9 = t4 === undefined ? {
      hidden: false,
      value: "",
      customClass: ""
    } : t4;
    $[6] = t4;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const timeAgo = t9;
  let t10;
  if ($[8] !== t5) {
    t10 = t5 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t5;
    $[8] = t5;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrc = t10;
  const categoryValue = category?.value || "";
  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const t11 = timeAgo?.value;
  let t12;
  if ($[10] !== t11) {
    t12 = getTimeAgo(t11);
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const timeAgoValue = t12;
  let t13;
  if ($[12] !== imageSrc?.value) {
    t13 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[12] = imageSrc?.value;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  const imageSrcValue = t13;
  let t14;
  if ($[14] !== sectionUrl) {
    t14 = getSectionUrl(sectionUrl);
    $[14] = sectionUrl;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const sectionUrlValue = t14;
  let t15;
  if ($[16] !== imageMetadata || $[17] !== imageSrc?.customClass || $[18] !== imageSrc?.hidden || $[19] !== imageSrcValue || $[20] !== titleValue) {
    t15 = !imageSrc?.hidden && <div className={imageSrc?.customClass || ""}><div className="relative w-full aspect-[16/9] overflow-hidden"><div className="absolute inset-0 flex items-center justify-center z-10" /><div className="absolute inset-0 flex items-center justify-center z-20"><PlayButton /></div><Image src={imageSrcValue} alt={titleValue} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 500px" className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading="lazy" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[16] = imageMetadata;
    $[17] = imageSrc?.customClass;
    $[18] = imageSrc?.hidden;
    $[19] = imageSrcValue;
    $[20] = titleValue;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== category?.customClass || $[23] !== category?.hidden || $[24] !== categoryValue || $[25] !== sectionUrlValue || $[26] !== slug) {
    t16 = !category?.hidden && (sectionUrlValue && !slug ? <Link href={sectionUrlValue} className={`text-11-tamil-600 text-012061 uppercase tracking-wide hover:underline ${category?.customClass || ""}`}>{categoryValue}</Link> : <span className={`text-11-tamil-600 text-012061 uppercase tracking-wide ${category?.customClass || ""}`}>{categoryValue}</span>);
    $[22] = category?.customClass;
    $[23] = category?.hidden;
    $[24] = categoryValue;
    $[25] = sectionUrlValue;
    $[26] = slug;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== title?.customClass || $[29] !== title?.hidden || $[30] !== titleValue) {
    t17 = !title?.hidden && <h3 className={`text-24-tamil-700 md:text-16-tamil-700 text-1B1B1B leading-[1.4] whitespace-pre-line ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[28] = title?.customClass;
    $[29] = title?.hidden;
    $[30] = titleValue;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== excerpt?.customClass || $[33] !== excerpt?.hidden || $[34] !== excerptValue) {
    t18 = !excerpt?.hidden && <p className={`text-12-tamil-400 text-4D4D4D opacity-70 leading-[1.4] line-clamp-2 ${excerpt?.customClass || ""}`}>{excerptValue}</p>;
    $[32] = excerpt?.customClass;
    $[33] = excerpt?.hidden;
    $[34] = excerptValue;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== timeAgo?.customClass || $[37] !== timeAgo?.hidden || $[38] !== timeAgoValue) {
    t19 = !timeAgo?.hidden && <p className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</p>;
    $[36] = timeAgo?.customClass;
    $[37] = timeAgo?.hidden;
    $[38] = timeAgoValue;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  const t20 = slug ? `/${slug}` : undefined;
  let t21;
  if ($[40] !== excerptValue || $[41] !== imageSrcValue || $[42] !== slug || $[43] !== t20 || $[44] !== titleValue) {
    t21 = <div className="flex gap-3"><MessageIcon id="small-image-news-vert-message-icon" variant="message-icon-4" slug={slug} category={BOOKMARK_CATEGORIES.VIDEOS} title={titleValue} thumbnailUrl={imageSrcValue} description={excerptValue} articleUrl={t20} /></div>;
    $[40] = excerptValue;
    $[41] = imageSrcValue;
    $[42] = slug;
    $[43] = t20;
    $[44] = titleValue;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t19 || $[47] !== t21) {
    t22 = <div className="flex justify-between items-center gap-2">{t19}{t21}</div>;
    $[46] = t19;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t16 || $[50] !== t17 || $[51] !== t18 || $[52] !== t22) {
    t23 = <div className="flex flex-col gap-2">{t16}{t17}{t18}{t22}</div>;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t15 || $[55] !== t23) {
    t24 = <div className="flex flex-col bg-transparent overflow-hidden p-4 gap-4">{t15}{t23}</div>;
    $[54] = t15;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  const content = t24;
  if (slug) {
    const t25 = `/${slug}`;
    let t26;
    if ($[57] !== content || $[58] !== t25) {
      t26 = <Link href={t25} className="block  transition-opacity cursor-pointer">{content}</Link>;
      $[57] = content;
      $[58] = t25;
      $[59] = t26;
    } else {
      t26 = $[59];
    }
    return t26;
  }
  return content;
};
export default VerticalBigVideoNewsBlack;